module.exports = __webpack_public_path__ + "static/img/13.518cd9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/artical/health/13.png
// module id = LUdH
// module chunks = 1